/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Livid_Weary_Turkey_CuddleInputs */

const es_livid_weary_turkey_cuddle = /** @type {(inputs: Livid_Weary_Turkey_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const gl_livid_weary_turkey_cuddle = /** @type {(inputs: Livid_Weary_Turkey_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrasinal`)
};

const en_livid_weary_turkey_cuddle = /** @type {(inputs: Livid_Weary_Turkey_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Livid_Weary_Turkey_CuddleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const livid_weary_turkey_cuddle = /** @type {((inputs?: Livid_Weary_Turkey_CuddleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Livid_Weary_Turkey_CuddleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_livid_weary_turkey_cuddle(inputs)
	if (locale === "en") return en_livid_weary_turkey_cuddle(inputs)
	return es_livid_weary_turkey_cuddle(inputs)
});